import { createAsyncThunk } from '@reduxjs/toolkit';
import { BuyTopService } from '../../../epics/common/top';

export const buyTop = createAsyncThunk('buyTop', (values) => {
    return BuyTopService.buyTop(values);
});

export const buyAdverts = createAsyncThunk('buyAdverts', (values) => {
    return BuyTopService.buyAdverts(values);
});

export const buyPremium = createAsyncThunk('buyPremium', (values) => {
    return BuyTopService.buyAdverts(values);
});